import { Link } from "react-router-dom";
import { BRAND_NAME, CATALOG_URL, BRAND_TAGLINE } from "@/mocks/site-config";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[100svh] flex items-center justify-center overflow-hidden z-[2]">
      {/* Background video */}
      <video
        src="https://public.readdy.ai/ai/video_res/019fb20f-705f-7412-aada-d7b266803e31.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 py-24 md:py-0 max-w-[1120px] mx-auto text-center">
        {/* Brand name + tag */}
        <div className="mb-8 md:mb-10">
          <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
            {BRAND_NAME}
          </h1>
          <p className="text-xs md:text-sm text-white/70 tracking-[0.15em] mt-2 font-medium">
            {BRAND_TAGLINE}
          </p>
        </div>

        {/* Main tagline */}
        <p className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-white leading-snug mb-5 md:mb-6">
          讓專業知識成為<span className="text-primary-300">可以持續閱讀</span>的內容
        </p>

        {/* Brand intro */}
        <p className="text-sm md:text-base text-white/80 leading-relaxed mb-8 md:mb-10 max-w-lg mx-auto">
          崧燁文化事業有限公司專注人文社會、教育研究、歷史文化、醫療保健與專業知識出版，透過清楚的內容整理與閱讀分類，讓研究成果、專業觀點與實用知識走進更多人的閱讀生活。
        </p>

        {/* Primary buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
          <Link
            to="/about"
            className="bg-white hover:bg-neutral-100 text-foreground-900 px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md"
          >
            品牌介紹 <i className="ri-building-2-line text-sm"></i>
          </Link>
          <Link
            to="/stores"
            className="bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md"
          >
            合作通路 <i className="ri-store-2-line text-sm"></i>
          </Link>
        </div>

        {/* Catalog link */}
        <a
          href={CATALOG_URL}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-300 hover:text-primary-200 cursor-pointer whitespace-nowrap transition-colors group"
        >
          <span className="w-5 h-px bg-primary-400/60 group-hover:bg-primary-300 transition-colors"></span>
          前往完整書籍資料庫
          <i className="ri-external-link-line text-xs"></i>
        </a>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden lg:block">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}